import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
// material
import { Container, Card, Box, Button, Typography, Divider, Stack } from '@material-ui/core';

// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import { useDispatch } from '../../../../redux/store';
import useSettings from '../../../../hooks/useSettings';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import FileUpload from "react-mui-fileuploader";
import downloadFill from '@iconify/icons-eva/download-fill';
import { Icon } from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import apiContact from '../../../../api/contact';
import axios from 'axios';
import { useSnackbar } from 'notistack5';
import LinearProgress from '@mui/material/LinearProgress';

// userSelected={userSelected}

// ----------------------------------------------------------------------
export default function UploadContact({ userSelected, departmentSelected, chooseType, setIsOpenImportContact, setIsRefreshContact }) {
    console.log({ userSelected, departmentSelected })
    const inputRef = useRef(null);

    const { themeStretch } = useSettings();
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [filesToUpload, setFilesToUpload] = useState([]);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const handleFilesChange = (files) => {
        // Update chosen files
        setFilesToUpload([...files]);
    };

    const uploadFiles = async () => {
        // Create a form and post it to server
        let formData = new FormData();
        if (filesToUpload.length > 0) {
            setLoadingUpload(true); // bật loading
            try {
                filesToUpload.forEach((file) => formData.append("contact_import", file));
                formData.append("type_import", chooseType)
                formData.append("assigned_by", userSelected)
                formData.append("department_id", departmentSelected)
                const res_upload_contact = await apiContact.upload_contact(formData);
                const error_msg = res_upload_contact.data;
                console.log(error_msg.message.length);
                enqueueSnackbar("Tạo thành công", { variant: 'success' });
                setFilesToUpload(null);

                if (parseInt(error_msg?.message?.length) > 0) {
                    setErrors(error_msg.message)
                } else {
                    setErrors([])
                    setIsOpenImportContact(false);
                }
                setIsRefreshContact(true);
                inputRef.current.value = null;

            } catch (error) {
                console.error(error);
                if (error.response?.data){
                    const error_msg = error.response?.data?.message;
                    setErrors(error_msg)
                    enqueueSnackbar(error_msg, { variant: 'error' });
                }
                // console.error(error);
            } finally {
                setLoadingUpload(false); // tắt loading sau khi xong
            }
        } else {
            enqueueSnackbar("Vui lòng chọn file thêm vào!!!", { variant: 'warning' });
        }
    };
    const dowloadTemplate = async () => {
        try {
            setLoading(true);
            const res_dowload_template = await apiContact.dowload_template_contact({ chooseType });

            const url = window.URL.createObjectURL(new Blob([res_dowload_template.data]));
            // tạo một thẻ a ẩn và kích hoạt sự kiện click để tải xuống tệp tin
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template_contact.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoading(false)
        } catch {
            setLoading(false)
        }


    }
    return (
        <Container maxWidth={themeStretch ? false : 'xl'}>
            <Box sx={{ p: 1 }}>
                <Box>
                    <Stack direction="row" justifyContent="center" spacing={2} >
                        <ContactPageIcon style={{ fontSize: '36px', marginTop: '10px', color: '#2978d5' }} ></ContactPageIcon>
                        <Typography variant='h4' style={{ marginTop: '10px' }}> Tải lên danh bạ</Typography>

                    </Stack>
                    <Typography variant='subtitle1' style={{ color: "#99abb4" }}> Tải lên danh bạ</Typography>
                </Box>
                <Divider />
                <Box sx={{ mt: 2, display: "flex", gap: "5px" }}>
                    <Typography>Các thông tin điền ứng với tên trường tóm tắt trong thông tin danh bạ được thể hiện ở dòng 1 trong file mẫu(Bạn vui lòng vào cài đặt danh bạ để tham khảo tên các trường tương ứng).Bạn có thể tải file mẫu để tham khảo và upload danh bạ.</Typography>
                </Box>
                <Box>
                    <LoadingButton
                        style={{ mt: 1 }}
                        size="small"
                        loading={loading}
                        variant="contained"
                        loadingPosition="end"
                        endIcon={<Icon icon={downloadFill} />}
                        onClick={() => dowloadTemplate()}
                    >
                        Tải xuống file mẫu
                    </LoadingButton>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <FileUpload
                        title="Upload File danh bạ"
                        header="Kéo thả file vào đây!!"
                        leftLabel='hoặc'
                        buttonLabel='Nhấp vào đây'
                        rightLabel='để chọn file!!'
                        maxUploadFiles={1}
                        multiFile={false}
                        onFilesChange={handleFilesChange}
                        onContextReady={(context) => { }}
                        ref={inputRef}
                    />
                    {loading && <LinearProgress />}
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={0.5}>
                    <Typography variant="body2">Chi tiết lỗi</Typography>
                    {errors && errors.map(err => {
                        return (
                            <Typography variant="subtitle1" color="red">{err}</Typography>
                        )
                    })}


                </Box>
                <Box sx={{ mt: 2 }}>
                    <LoadingButton onClick={uploadFiles} loading={loadingUpload} variant="contained" id="uploadButton">
                        Tải lên
                    </LoadingButton>
                </Box>
            </Box>
        </Container >
    );
}
